export default __webpack_public_path__ + "static/media/1295.40acb36a.png";